import { useGetBuiltinUsersQuery } from "@/api/api";
import { Skeleton } from "../../skeleton";
import FeaturedUserCard from "./FeaturedUserCard";
import { FEATURED_SECTION_ID } from "./scroll";

/**
 * The admin-curated shelf, as something to read rather than something to
 * switch to.
 *
 * `/builtin-users` is the same list `SpaceSwitcher` offers a signed-out visitor
 * in place of the subscriptions they do not have; it needs no session and
 * answers the same for everyone.
 *
 * Nothing at all rather than an empty shelf: a marketing page that says "spaces
 * worth reading" over a blank grid argues against itself. The same goes for a
 * failed request — there is no error worth showing a stranger here.
 */
export default function FeaturedUsers() {
  const { data, isLoading } = useGetBuiltinUsersQuery();

  if (!isLoading && !data?.length) return null;

  return (
    <section id={FEATURED_SECTION_ID} className="scroll-mt-6 border-t pt-10">
      <h2
        className="text-[15px] font-semibold text-foreground"
        style={{ fontFamily: "var(--font-serif)" }}
      >
        Spaces worth reading
      </h2>
      <p className="mt-1 text-[13.5px] text-ink2">
        Public timelines you can open right now, without an account.
      </p>

      <div className="mt-5 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {isLoading
          ? Array.from({ length: 3 }, (_, i) => (
              <Skeleton key={i} className="h-[124px] rounded-xl" />
            ))
          : data?.map((user) => (
              <FeaturedUserCard key={user.id} user={user} />
            ))}
      </div>
    </section>
  );
}
